<template>
  <router-view />
</template>

<script>
import UserLogin from "@/components/UserLogin.vue";

export default {
  name: 'App',
  components: {
    UserLogin: UserLogin,
  }
}
</script>

<style>
#app {
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;  /* 禁止 body 滚动 */
}
</style>
